export function setItemInLocalStorage(key: string, value: string): void {
  localStorage.setItem(key, value)
}

export function getItemInLocalStorage(key: string): string | null {
  return localStorage.getItem(key)
}

export function removeItemInLocalStorage(key: string): void {
  localStorage.removeItem(key)
}
